import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import StylishDateTimePicker from '../../DesignSystems/form/StylishDateTimePicker';

type ValidationRule = {
  value: any;
  message: string;
};

type ValidationRules = {
  required?: ValidationRule;
  validate?: (value: string) => boolean | string;
};

type FormDateTimeFieldProps = {
  title: string;
  fieldName: string;
  rules?: ValidationRules;
  variant?: 'full' | 'half' | 'third';
  type?: 'datetime-local';
  disabled?: boolean;
  timeZone?: boolean;
  timeZoneValue?: number;
  timeZoneLabel?: boolean;
  onTimeZoneChange?: (option: { label: string; value: number }) => void;
};

const FormDateTimeField: React.FC<FormDateTimeFieldProps> = ({
  title,
  fieldName,
  rules,
  variant = 'full',
  type,
  disabled = false,
  timeZone,
  timeZoneValue,
  timeZoneLabel,
  onTimeZoneChange,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const required = typeof rules?.required === 'object';

  return (
    <div
      className={classNames('mt-2', {
        'col-6': variant === 'half',
        'col-12': variant === 'full',
        'col-4': variant === 'third',
      })}
    >
      <Controller
        control={control}
        name={fieldName}
        rules={rules}
        render={({ field: { onChange, onBlur, value } }) => (
          <StylishDateTimePicker
            onChange={(date) => onChange(date)}
            onBlur={onBlur}
            value={value}
            dateLabel={title}
            required={required}
            type={type || 'datetime-local'}
            disabled={disabled}
            timeZone={timeZone}
            timeZoneValue={timeZoneValue}
            timeZoneLabel={timeZoneLabel}
            onTimeZoneChange={onTimeZoneChange}
          />
        )}
      />
      {errors[fieldName] ? (
        <div className="form-text form-error">
          {errors[fieldName].message as string}
        </div>
      ) : (
        <div className="form-text-none"></div>
      )}
    </div>
  );
};
export default FormDateTimeField;
